import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, ToastController, ViewController } from 'ionic-angular';
import { EventProvider } from '../../../providers/event/event';
import { SessionProvider } from '../../../providers/session/session';
import { PaymentService, Product, ProductType } from '../../../providers/payment.service';
import { User } from '../../../components/payment/payment';
import { UserProvider } from '../../../providers/user/user';
import { AdsProvider } from '../../../providers/ads/ads';

@Component({
  selector: 'page-premium-payment',
  templateUrl: 'premium-payment.html'
})
export class PremiumPaymentPage {
  price: number = 29;
  currency: string = "eur";
  product: Product = null;
  user: User = null;

  constructor(
    private adsService: AdsProvider,
    private sessionService: SessionProvider,
    private toastController: ToastController,
    private translate: TranslateService,
    private viewController: ViewController,
    private userService: UserProvider
  ) { }

  cancel() {
    this.viewController.dismiss();
  }

  ionViewDidLoad() {
    this.currency = this.translate.defaultLang.includes('de') ? "eur" : "usd";
    this.product = {
      price: this.price,
      currency: this.currency,
      type: ProductType.PREMIUM
    };
    this.user = {
      name: `${this.sessionService.profile.forName} ${this.sessionService.profile.surName}`,
      email: "klewerenz@me.com"
    };
  }

  showToast(translation, extra = false) {
    let message = extra
      ? this.translate.instant(translation, { amount: this.price, currency: this.currency })
      : this.translate.instant(translation);

    this.toastController.create({
      message: message,
      duration: 5000,
      position: 'top'
    }).present();
  }

  onCompletePayment(result) {
    return new Promise<any>((resolve, reject) => {
      if (result) {
        let profile = this.sessionService.profile;
        profile.premium = true;
        this.userService.updateProfile(profile).then((res) => {
          if (res) {
            localStorage.setItem('premium', JSON.stringify(true));
            this.adsService.hide();
            this.viewController.dismiss();
            resolve(true);
          }
        }).catch(err => {
          reject(err);
        })
      }
    });
  }
}


// WEBPACK FOOTER //
// /src/pages/premium/premium-payment/premium-payment.ts